import * as React from "react";
const SvgFiRrCow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cow_svg__a)">
      <path
        fill="#062147"
        d="M23.63 3.845A2.02 2.02 0 0 0 21.989 3h-3.543c.518-.847 1.1-2.892-.445-3a1 1 0 0 0-1 1 2 2 0 0 1-2 2H9a2 2 0 0 1-2-2 1 1 0 0 0-1-1c-1.548.109-.962 2.152-.444 3H2.012A2.008 2.008 0 0 0 .1 5.614a6.9 6.9 0 0 0 2.92 3.525c0 .035 3 12.065 3 12.065A2.994 2.994 0 0 0 9 24h6a2.994 2.994 0 0 0 2.98-2.8s3-12.03 3-12.065a6.9 6.9 0 0 0 2.92-3.52 1.94 1.94 0 0 0-.27-1.77m-5.25 4.117A5.11 5.11 0 0 0 13 13v5h-2v-5a5.11 5.11 0 0 0-5.38-5.038A9.9 9.9 0 0 1 8.342 4.99l7.3.01a9.8 9.8 0 0 1 2.739 2.962M2.013 5h3.321a12.2 12.2 0 0 0-1.6 2.221A4.7 4.7 0 0 1 2.013 5M6 10c.353.003.703.069 1.032.194a1.507 1.507 0 0 0 1.774 1.774c.126.33.192.68.194 1.032v5a2.97 2.97 0 0 0-1.6.472L5.263 9.929q.366.06.737.071m9 12H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2m1.6-3.528A2.97 2.97 0 0 0 15 18v-5c.003-.353.07-.702.194-1.032a1.507 1.507 0 0 0 1.774-1.774 7.8 7.8 0 0 1 1.77-.265zm3.665-11.257a12 12 0 0 0-1.616-2.24L22 4.97a4.8 4.8 0 0 1-1.735 2.245"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCow;
